import dayjs from 'dayjs';
import { ALL_CUSTOMERS_ID, ALL_SITES_ID } from '@/queries/logs';
import { DateFilter } from '@/features/dashboard/types';
import { CustomDateRange } from '@/shared/types/date';
import { SelectedLocation } from '@/features/dashboard/widgets/completed-cycles/filters/LocationFiltersDialog';

export interface FilterState {
	selectedSiteId: string | undefined;
	customerId: string | undefined;
	dateFilter: DateFilter;
	customRangeFilter: CustomDateRange;
	locationsFilter: SelectedLocation[];
}

export const getDefaultFilterState = (): FilterState => ({
	selectedSiteId: ALL_SITES_ID,
	customerId: ALL_CUSTOMERS_ID,
	dateFilter: DateFilter.LAST_7_DAYS,
	customRangeFilter: {
		start: dayjs().subtract(1, 'week').startOf('week'),
		end: dayjs().subtract(1, 'week').endOf('week'),
	},
	locationsFilter: [],
});
